import { createTheme } from "@mui/material/styles";
import { blue, red } from "@mui/material/colors";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#b860e5",
    },
    secondary: blue,
    error: red,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 426,
      md: 768,
      lg: 1200,
      xl: 1920,
    },
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          maxWidth: 600,
        },
      },
    },
  },
});

export const green_chart_color = "#3cad66";
export const purple_chart_color = "#9c27b0";
export const blue_chart_color = "#61b0ca";
export const orange_chart_color = "#ffab00";
export const red_chart_color = "#f1512c";
export const grey_chart_color = "#e1e1e1";
